import { createAction } from 'redux-actions';

export const loginSuccess = createAction('HANDLE_LOGIN_FULFILLED');
export const authSuccess = createAction('FETCH_CREDENTIALS_FULFILLED');
export const logoutSuccess = createAction('HANDLE_LOGOUT_FULFILLED');
export const loginRejected = createAction('HANDLE_LOGIN_REJECTED');
export const authRejected = createAction('FETCH_CREDENTIALS_REJECTED');
export const logoutRejected = createAction('HANDLE_LOGOUT_REJECTED');
export const loginPending = createAction('HANDLE_LOGIN_PENDING');
export const authPending = createAction('FETCH_CREDENTIALS_PENDING');
export const logoutPending = createAction('HANDLE_LOGOUT_PENDING');

export default {
  loginSuccess,
  authSuccess,
  logoutSuccess,
  loginRejected,
  authRejected,
  logoutRejected,
  loginPending,
  logoutPending,
};
